import { Loadable } from 'loankeeper-common/components/hocs/LazyLoading'
import { createNavigationConfig } from 'loankeeper-common/components'

export const ACTIVE_USERS_FORM_MODAL = 'ActiveUsersModal'

const ActiveUsersFormModal = Loadable(() => import('./ActiveUsersForm'))

export const createActiveUsersNavigationItem = createNavigationConfig((translateFn: (key: string) => string) => ({
  icon: 'zap',
  text: translateFn('mnu_file_sysprocess'),
  identity: ACTIVE_USERS_FORM_MODAL,
  permission: 'SYSPROCESS_VIEW',
  component: ActiveUsersFormModal,
}))
